<button
    type="button"
    class="interest-register-card relative flex flex-col p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
    [ngClass]="config.accentClass"
    [style.--interest-register-accent]="config.accentColor"
    (click)="select()"
>
    <div class="absolute bottom-0 right-0 w-24 h-24 -m-6 interest-register-card__watermark">
        <mat-icon class="icon-size-24" [svgIcon]="config.icon"></mat-icon>
    </div>

    <div class="flex items-center">
        <div class="flex flex-col min-w-0 pr-16">
            <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                {{ config.title }}
            </div>

            <div class="text-secondary font-medium text-md leading-5">
                {{ config.description }}
            </div>
        </div>
    </div>

    <span class="text-md c-link mt-2 text-primary inline-flex items-center gap-1">
        {{ config.actionText }}
        <mat-icon class="icon-size-4 interest-register-card__arrow" [svgIcon]="'heroicons_outline:arrow-right'"></mat-icon>
    </span>
</button>
